export default "__VITE_ASSET__DVT9vq4n__"